export const RegionTypes = {
	Global: 'ae',
	SaudiArabia: 'sa',
};
